import { render } from "./FarmersPage.vue?vue&type=template&id=065e8216"
import script from "./FarmersPage.vue?vue&type=script&lang=js"
export * from "./FarmersPage.vue?vue&type=script&lang=js"

import "./FarmersPage.vue?vue&type=style&index=0&id=065e8216&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__